"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var AppModule_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
//imports for @angular library components
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const common_1 = require("@angular/common");
//imports for non @angular library components
const multiselect_dropdown_1 = require("./multiselect-dropdown");
const ng2_dragula_1 = require("ng2-dragula");
const ng2_pagination_1 = require("ng2-pagination");
const ngx_bootstrap_1 = require("ngx-bootstrap");
const angular2_moment_1 = require("angular2-moment");
const angular2_modal_1 = require("angular2-modal");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const ngx_charts_1 = require("@swimlane/ngx-charts");
const ng2_daterangepicker_1 = require("ng2-daterangepicker");
const components_1 = require("angular2-bootstrap-switch/components");
const ng2_select_1 = require("ng2-select");
//imports for app components and services
const app_component_1 = require("./app.component");
const header_component_1 = require("./header.component");
const footer_component_1 = require("./footer.component");
const app_service_1 = require("./app.service");
const notification_service_1 = require("./notification.service");
const list_component_1 = require("./list.component");
const bidder_component_1 = require("./bidder.component");
const login_component_1 = require("./login.component");
const onboard_component_1 = require("./onboard.component");
const control_center_metrics_component_1 = require("./control-center-metrics.component");
const admin_component_1 = require("./admin.component");
const bidder_service_1 = require("./bidder.service");
const demand_partner_service_1 = require("./demand-partner.service");
const demand_partner_type_service_1 = require("./demand-partner-type.service");
const login_service_1 = require("./login.service");
const onboard_service_1 = require("./onboard.service");
const user_service_1 = require("./user.service");
const users_service_1 = require("./users.service");
const admin_service_1 = require("./admin.service");
const token_service_1 = require("./token.service");
const version_service_1 = require("./version.service");
const organizations_service_1 = require("./organizations.service");
const clients_service_1 = require("./clients.service");
const roles_service_1 = require("./roles.service");
const permission_service_1 = require("./permission.service");
const permissions_service_1 = require("./permissions.service");
const auth_guard_service_1 = require("./auth-guard.service");
const app_routing_1 = require("./app.routing");
const loading_service_1 = require("./loading.service");
const loading_component_1 = require("./loading.component");
const org_switch_component_1 = require("./org-switch.component");
const slug_pipe_1 = require("./slug.pipe");
const order_by_pipe_1 = require("./order-by.pipe");
const order_by_impure_pipe_1 = require("./order-by-impure.pipe");
const search_pipe_1 = require("./search.pipe");
const search_custom_pipe_1 = require("./search-custom.pipe");
const search_if_key_value_pipe_1 = require("./search-if-key-value.pipe");
const optional_search_with_array_pipe_1 = require("./optional-search-with-array.pipe");
const search_slug_pipe_1 = require("./search-slug.pipe");
const search_with_array_pipe_1 = require("./search-with-array.pipe");
const search_object_key_with_array_pipe_1 = require("./search-object-key-with-array.pipe");
const search_box_component_1 = require("./search-box.component");
const check_key_pipe_1 = require("./check-key.pipe");
const check_demand_partner_type_pipe_1 = require("./check-demand-partner-type.pipe");
const role_index_pipe_1 = require("./role-index.pipe");
const org_index_pipe_1 = require("./org-index.pipe");
const version_pipe_1 = require("./version.pipe");
const size_service_1 = require("./size.service");
const size_pipe_1 = require("./size.pipe");
const price_bucket_service_1 = require("./price-bucket.service");
const admin_user_component_1 = require("./admin-user.component");
const user_form_component_1 = require("./user-form.component");
const user_list_component_1 = require("./user-list.component");
const user_list_row_component_1 = require("./user-list-row.component");
const user_list_row_edit_component_1 = require("./user-list-row-edit.component");
const admin_organization_component_1 = require("./admin-organization.component");
const admin_clients_component_1 = require("./admin-clients.component");
const admin_beautifier_component_1 = require("./admin-beautifier.component");
const admin_permissions_component_1 = require("./admin-permissions.component");
const admin_demand_partners_component_1 = require("./admin-demand-partners.component");
const admin_size_component_1 = require("./admin-size.component");
const admin_mass_update_component_1 = require("./admin-mass-update.component");
const admin_managers_component_1 = require("./admin-managers.component");
const admin_dashboard_filters_component_1 = require("./admin-dashboard-filters.component");
const admin_cdn_purge_component_1 = require("./admin-cdn-purge.component");
const integration_service_1 = require("./integration.service");
const forgot_password_component_1 = require("./forgot-password.component");
const reset_password_component_1 = require("./reset-password.component");
const bid_data_service_1 = require("./bid-data.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const dashboard_component_1 = require("./dashboard.component");
const portal_component_1 = require("./portal.component");
const welcome_component_1 = require("./welcome.component");
const collapse_text_component_1 = require("./collapse-text.component");
const boolean_key_pipe_1 = require("./boolean-key.pipe");
const preferences_service_1 = require("./preferences.service");
const ad_unit_component_1 = require("./ad-unit.component");
const demand_partner_component_1 = require("./demand-partner.component");
const demand_partner_param_component_1 = require("./demand-partner-param.component");
const mousewheel_directive_1 = require("./mousewheel.directive");
const bid_data_rollup_service_1 = require("./bid-data-rollup.service");
const can_deactivate_guard_service_1 = require("./can-deactivate-guard.service");
const demand_partner_menu_service_1 = require("./demand-partner-menu.service");
const demand_partner_menu_component_1 = require("./demand-partner-menu.component");
const dashboard_report_service_1 = require("./dashboard-report.service");
const focus_directive_1 = require("./focus.directive");
const show_hide_input_directive_1 = require("./show-hide-input.directive");
const size_mapping_menu_component_1 = require("./size-mapping-menu.component");
const size_mapping_menu_service_1 = require("./size-mapping-menu.service");
const changelog_modal_component_1 = require("./changelog-modal.component");
const changelog_component_1 = require("./changelog.component");
const changelog_service_1 = require("./changelog.service");
const user_id_pipe_1 = require("./user-id.pipe");
const support_modal_component_1 = require("./support-modal.component");
const angular2_sails_1 = require("angular2-sails");
const test_line_automation_component_1 = require("./test-line-automation.component");
const lineitem_automation_service_1 = require("./lineitem-automation.service");
const notifier_service_1 = require("./notifier.service");
const notifier_component_1 = require("./notifier.component");
const lineitem_automation_component_1 = require("./lineitem-automation.component");
const line_item_config_selection_component_1 = require("./line-item-config-selection.component");
const queue_manager_component_1 = require("./queue-manager.component");
const queue_manager_service_1 = require("./queue-manager.service");
const dynamic_timeout_modal_component_1 = require("./dynamic-timeout-modal.component");
const data_metric_service_1 = require("./data-metric.service");
const admin_bidder_component_1 = require("./admin-bidder.component");
const data_filter_component_1 = require("./data-filter.component");
const system_notification_service_1 = require("./system-notification.service");
const user_settings_component_1 = require("./user-settings.component");
const timezone_selector_component_1 = require("./timezone-selector.component");
const change_email_component_1 = require("./change-email.component");
const update_dfp_networks_component_1 = require("./update-dfp-networks.component");
const price_bucket_component_1 = require("./price-bucket.component");
const organization_id_pipe_1 = require("./organization-id.pipe");
const ng2_cookies_1 = require("ng2-cookies");
const data_level_service_1 = require("./data-level.service");
const organization_data_level_pipe_1 = require("./organization-data-level.pipe");
const organization_list_row_edit_component_1 = require("./organization-list-row-edit.component");
const ad_unit_service_1 = require("./ad-unit.service");
const admin_notification_component_1 = require("./admin-notification.component");
const dashboard_export_component_1 = require("./dashboard-export.component");
const websocket_service_1 = require("./websocket.service");
const does_exist_pipe_1 = require("./does-exist.pipe");
const data_source_service_1 = require("./data-source.service");
const filter_metric_service_1 = require("./filter-metric.service");
const product_service_1 = require("./product.service");
const input_debounce_1 = require("./input-debounce");
const filter_metric_management_component_1 = require("./filter-metric-management.component");
const metric_formatter_pipe_1 = require("./metric-formatter.pipe");
const dashboard_timeout_alert_component_1 = require("./dashboard-timeout-alert.component");
const branding_service_1 = require("./branding.service");
const adjustment_component_1 = require("./adjustment.component");
const adjustment_table_component_1 = require("./adjustment-table.component");
const adjustment_row_component_1 = require("./adjustment-row.component");
const adjustment_data_component_1 = require("./adjustment-data.component");
const adjustment_search_component_1 = require("./adjustment-search.component");
const adjustment_submit_component_1 = require("./adjustment-submit.component");
const adjustment_import_download_component_1 = require("./adjustment-import-download.component");
const adjustment_import_upload_component_1 = require("./adjustment-import-upload.component");
const exchange_service_1 = require("./exchange.service");
const update_dfp_networks_modal_component_1 = require("./update-dfp-networks-modal.component");
const connect_management_component_1 = require("./connect-management.component");
const connect_management_organization_component_1 = require("./connect-management-organization.component");
const connect_management_clients_component_1 = require("./connect-management-clients.component");
const connect_management_users_component_1 = require("./connect-management-users.component");
const connect_management_save_user_modal_component_1 = require("./connect-management-save-user-modal.component");
const connect_management_save_client_modal_component_1 = require("./connect-management-save-client-modal.component");
const bidder_adUnits_resolver_1 = require("./bidder-adUnits.resolver");
const edit_bidder_resolver_1 = require("./edit-bidder.resolver");
//NgModule classes
let AppModule = AppModule_1 = class AppModule {
    constructor(injector) {
        AppModule_1.injector = injector;
    }
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = AppModule_1 = __decorate([
    (0, core_1.NgModule)({
        imports: [
            platform_browser_1.BrowserModule,
            ngx_bootstrap_1.TabsModule.forRoot(),
            ngx_bootstrap_1.TooltipModule.forRoot(),
            ngx_bootstrap_1.BsDropdownModule.forRoot(),
            ngx_bootstrap_1.DatepickerModule.forRoot(),
            angular2_modal_1.ModalModule.forRoot(),
            ngx_bootstrap_1.CollapseModule.forRoot(),
            ngx_bootstrap_1.ProgressbarModule.forRoot(),
            ngx_bootstrap_1.PopoverModule.forRoot(),
            bootstrap_1.BootstrapModalModule,
            forms_1.ReactiveFormsModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            app_routing_1.routing,
            multiselect_dropdown_1.MultiselectDropdownModule,
            ng2_dragula_1.DragulaModule,
            ng2_pagination_1.Ng2PaginationModule,
            angular2_moment_1.MomentModule,
            ngx_charts_1.NgxChartsModule,
            ng2_select_1.SelectModule,
            ng2_daterangepicker_1.Daterangepicker,
            angular2_sails_1.SailsModule.forRoot()
        ],
        declarations: [
            app_component_1.AppComponent,
            header_component_1.HeaderComponent,
            footer_component_1.FooterComponent,
            list_component_1.ListComponent,
            control_center_metrics_component_1.ControlCenterMetricsComponent,
            bidder_component_1.EditBidderComponent,
            login_component_1.LoginComponent,
            onboard_component_1.OnboardComponent,
            admin_component_1.AdminComponent,
            loading_component_1.LoadingComponent,
            notifier_component_1.NotifierComponent,
            org_switch_component_1.OrgSwitchComponent,
            order_by_pipe_1.OrderByPipe,
            order_by_impure_pipe_1.OrderByImpurePipe,
            search_pipe_1.SearchPipe,
            search_custom_pipe_1.SearchCustomPipe,
            search_if_key_value_pipe_1.SearchIfKeyValuePipe,
            optional_search_with_array_pipe_1.OptionalSearchWithArrayPipe,
            search_slug_pipe_1.SearchSlugPipe,
            search_with_array_pipe_1.SearchWithArrayPipe,
            search_object_key_with_array_pipe_1.SearchObjectKeyWithArrayPipe,
            search_box_component_1.SearchBoxComponent,
            check_key_pipe_1.CheckKeyPipe,
            check_demand_partner_type_pipe_1.CheckDemandPartnerTypePipe,
            role_index_pipe_1.RoleIndexPipe,
            org_index_pipe_1.OrgIndexPipe,
            version_pipe_1.VersionPipe,
            size_pipe_1.SizeIdPipe,
            size_pipe_1.SizeNamePipe,
            boolean_key_pipe_1.BooleanKeyPipe,
            user_id_pipe_1.UserIdPipe,
            organization_id_pipe_1.OrganizationIdPipe,
            organization_data_level_pipe_1.OrganizationDataLevelPipe,
            organization_list_row_edit_component_1.OrganizationListRowEditComponent,
            admin_user_component_1.AdminUserComponent,
            user_form_component_1.UserFormComponent,
            user_list_component_1.UserListComponent,
            user_list_row_component_1.UserListRowComponent,
            user_list_row_edit_component_1.UserListRowEditComponent,
            admin_organization_component_1.AdminOrganizationComponent,
            admin_clients_component_1.AdminClientsComponent,
            admin_beautifier_component_1.AdminBeautifierComponent,
            admin_permissions_component_1.AdminPermissionsComponent,
            admin_demand_partners_component_1.AdminDemandPartnersComponent,
            admin_size_component_1.AdminSizeComponent,
            admin_mass_update_component_1.AdminMassUpdateComponent,
            admin_bidder_component_1.AdminBidderComponent,
            forgot_password_component_1.ForgotPasswordComponent,
            reset_password_component_1.ResetPasswordComponent,
            admin_managers_component_1.AdminManagersComponent,
            admin_dashboard_filters_component_1.AdminFiltersComponent,
            admin_cdn_purge_component_1.AdminCdnPurgeComponent,
            dashboard_component_1.DashboardComponent,
            portal_component_1.PortalComponent,
            welcome_component_1.WelcomeComponent,
            collapse_text_component_1.CollapseTextComponent,
            components_1.SwitchComponent,
            ad_unit_component_1.AdUnitComponent,
            demand_partner_component_1.DemandPartnerComponent,
            demand_partner_param_component_1.DemandPartnerParamComponent,
            mousewheel_directive_1.MouseWheelDirective,
            show_hide_input_directive_1.ShowHideInputDirective,
            demand_partner_menu_component_1.DemandPartnerMenuComponent,
            focus_directive_1.FocusDirective,
            size_mapping_menu_component_1.SizeMappingMenuComponent,
            changelog_modal_component_1.ChangeLogModalComponent,
            changelog_component_1.ChangeLogComponent,
            update_dfp_networks_modal_component_1.UpdateDfpNetworksModalComponent,
            support_modal_component_1.SupportModalComponent,
            test_line_automation_component_1.TestLineItemAutomationComponent,
            lineitem_automation_component_1.LineItemAutomationComponent,
            line_item_config_selection_component_1.LineItemConfigSelection,
            queue_manager_component_1.QueueManagerComponent,
            dynamic_timeout_modal_component_1.DynamicTimeoutModalComponent,
            data_filter_component_1.DataFilterComponent,
            user_settings_component_1.UserSettingsComponent,
            timezone_selector_component_1.TimezoneSelectorComponent,
            change_email_component_1.ChangeEmailComponent,
            update_dfp_networks_component_1.UpdateDfpNetworksComponent,
            price_bucket_component_1.PriceBucketComponent,
            admin_notification_component_1.AdminNotificationComponent,
            price_bucket_component_1.PriceBucketComponent,
            dashboard_export_component_1.DashboardExportComponent,
            does_exist_pipe_1.DoesExistPipe,
            input_debounce_1.InputDebounceComponent,
            filter_metric_management_component_1.FilterMetricManagement,
            metric_formatter_pipe_1.MetricFormatterPipe,
            dashboard_timeout_alert_component_1.DashboardTimeoutAlert,
            adjustment_component_1.AdjustmentComponent,
            adjustment_table_component_1.AdjustmentTableComponent,
            adjustment_row_component_1.AdjustmentRowComponent,
            adjustment_data_component_1.AdjustmentDataComponent,
            adjustment_search_component_1.AdjustmentSearchComponent,
            adjustment_submit_component_1.AdjustmentSubmitComponent,
            adjustment_import_download_component_1.AdjustmentImportDownloadComponent,
            adjustment_import_upload_component_1.AdjustmentImportUploadComponent,
            connect_management_component_1.ConnectManagementComponent,
            connect_management_organization_component_1.ConnectManagementOrganizationComponent,
            connect_management_clients_component_1.ConnectManagementClientsComponent,
            connect_management_users_component_1.ConnectManagementUsersComponent,
            connect_management_save_user_modal_component_1.ConnectManagementSaveUserModalComponent,
            connect_management_save_client_modal_component_1.ConnectManagementSaveClientModalComponent
        ],
        providers: [
            app_service_1.AppService,
            notification_service_1.NotificationService,
            product_service_1.ProductService,
            branding_service_1.BrandingService,
            notifier_service_1.NotifierService,
            ngx_bootstrap_1.TooltipConfig,
            ngx_bootstrap_1.ProgressbarConfig,
            ngx_bootstrap_1.TabsetConfig,
            bidder_service_1.BidderService,
            demand_partner_service_1.DemandPartnerService,
            demand_partner_type_service_1.DemandPartnerTypeService,
            login_service_1.LoginService,
            onboard_service_1.OnboardService,
            user_service_1.UserService,
            users_service_1.UsersService,
            admin_service_1.AdminService,
            token_service_1.TokenService,
            version_service_1.VersionService,
            organizations_service_1.OrganizationsService,
            clients_service_1.ClientsService,
            roles_service_1.RolesService,
            permission_service_1.PermissionService,
            permissions_service_1.PermissionsService,
            loading_service_1.LoadingService,
            size_service_1.SizeService,
            price_bucket_service_1.PriceBucketService,
            auth_guard_service_1.AuthGuard,
            common_1.DecimalPipe,
            common_1.DatePipe,
            order_by_pipe_1.OrderByPipe,
            order_by_impure_pipe_1.OrderByImpurePipe,
            slug_pipe_1.SlugPipe,
            search_with_array_pipe_1.SearchWithArrayPipe,
            search_object_key_with_array_pipe_1.SearchObjectKeyWithArrayPipe,
            search_pipe_1.SearchPipe,
            search_custom_pipe_1.SearchCustomPipe,
            search_if_key_value_pipe_1.SearchIfKeyValuePipe,
            optional_search_with_array_pipe_1.OptionalSearchWithArrayPipe,
            check_key_pipe_1.CheckKeyPipe,
            check_demand_partner_type_pipe_1.CheckDemandPartnerTypePipe,
            version_pipe_1.VersionPipe,
            size_pipe_1.SizeIdPipe,
            size_pipe_1.SizeNamePipe,
            angular2_moment_1.DateFormatPipe,
            boolean_key_pipe_1.BooleanKeyPipe,
            user_id_pipe_1.UserIdPipe,
            organization_id_pipe_1.OrganizationIdPipe,
            organization_data_level_pipe_1.OrganizationDataLevelPipe,
            ng2_dragula_1.DragulaService,
            integration_service_1.IntegrationService,
            ngx_bootstrap_1.ComponentLoaderFactory,
            ngx_bootstrap_1.PositioningService,
            bid_data_service_1.BidDataService,
            bid_data_filter_service_1.BidDataFilterService,
            preferences_service_1.PreferencesService,
            bid_data_rollup_service_1.BidDataRollupService,
            can_deactivate_guard_service_1.CanDeactivateGuardService,
            demand_partner_menu_service_1.DemandPartnerMenuService,
            dashboard_report_service_1.DashboardReportService,
            size_mapping_menu_service_1.SizeMappingMenuService,
            changelog_service_1.ChangeLogService,
            lineitem_automation_service_1.LineAutomationService,
            queue_manager_service_1.QueueManagerService,
            data_metric_service_1.DataMetricService,
            system_notification_service_1.SystemNotificationService,
            ng2_cookies_1.CookieService,
            data_level_service_1.DataLevelService,
            ad_unit_service_1.AdUnitService,
            websocket_service_1.WebSocketService,
            does_exist_pipe_1.DoesExistPipe,
            data_source_service_1.DataSourceService,
            filter_metric_service_1.FilterMetricService,
            metric_formatter_pipe_1.MetricFormatterPipe,
            exchange_service_1.ExchangeService,
            { provide: common_1.LocationStrategy, useClass: common_1.HashLocationStrategy },
            bidder_adUnits_resolver_1.BidderAdUnitsResolver,
            edit_bidder_resolver_1.EditBidderResolver
        ],
        bootstrap: [app_component_1.AppComponent],
        entryComponents: [
            changelog_modal_component_1.ChangeLogModalComponent,
            support_modal_component_1.SupportModalComponent,
            dynamic_timeout_modal_component_1.DynamicTimeoutModalComponent,
            update_dfp_networks_modal_component_1.UpdateDfpNetworksModalComponent,
            connect_management_save_user_modal_component_1.ConnectManagementSaveUserModalComponent,
            connect_management_save_client_modal_component_1.ConnectManagementSaveClientModalComponent
        ]
    }),
    __metadata("design:paramtypes", [core_1.Injector])
], AppModule);
//# sourceMappingURL=app.module.js.map